<template>
  <div>
    <div>
      <!-- <v-select
        class=""
        id="searchKey"
        @change="searchdata"
        insertContains="searchKey"
        v-model="searchKey"
        name="searchKey1"
        :options="searchKeyOptions"
      ></v-select>
      <v-input
        class="ml10"
        v-model="searchData"
        placeholder="请输入"
        suffix-icon="v-icon-search"
        @change="searchdata"
      ></v-input> -->
    </div>
    <div class="mt10">
      <vxe-table row-id="id" :data="table" align="left">
        <vxe-table-column  field="dev_name" show-overflow min-width="80" title="设备名称"></vxe-table-column>
          <!-- <vxe-table-column  field="dev_status" show-overflow min-width="120" title="设备状态"></vxe-table-column> -->
          <vxe-table-column  field="product_name" show-overflow min-width="120" title="所属产品"></vxe-table-column>
          <vxe-table-column  field="group_name" show-overflow min-width="120" title="所在分组"></vxe-table-column>
          <vxe-table-column  field="created_at_str" show-overflow min-width="120" title="创建时间"></vxe-table-column>
        <vxe-column title="操作" min-width="140">
          <template v-slot="slotProps">
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn-text1"
                slot="reference"
                @click="openViewModel(slotProps.row)"
                >查看</v-button
              ></span
            >
            <span class="handle-button"
              ><v-button
                size="S"
                type="text"
                name="btn-text1"
                slot="reference"
                @click="openDelModel(slotProps.row)"
                >从分组中删除</v-button
              ></span
            >
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage" ></v-pagination>

    <RemoveGroup :showInputDialog.sync="RemoveGrouploading" ref="RemoveGroup" :devId="devId" @getData="getData"></RemoveGroup>
  </div>
</template>

<script>
import RemoveGroup from "./remove-group.vue";

export default {
  components: {RemoveGroup},
  props: {
    groupId:{}
  },
  data() {
    return {
      activeNamebutton: "",
      RemoveGrouploading: false,
      searchData: "",
      table: [],
      searchKey: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      devId:'',
      searchKeyOptions: [
        {
          label: "全部产品",
          value: "sn",
        },
      ],
    };
  },
  created() {
    this.getData()
  },

  methods: {
    searchdata() {},
    openDelModel(row) {
      this.devId = row.id
      this.RemoveGrouploading = !this.RemoveGrouploading;
    },
    async getData() {
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        group_id: Number(this.groupId),
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/dev/page/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data.list;
        this.total = res.data.page.total;
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    changePage(page){
      this.currentPage = Number(page)
      this.getData()
    },
    changeSize(size){
      this.pageSize = Number(size)
      this.currentPage = 1
      this.getData()
    },
    openViewModel(row) {
      //跳转路由
      this.$router.push({
        name: "/deviceInfo-manage/device-details-info",
        query: { name: row.dev_name, id: row.id, key: row.dev_key },
      });
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
</style>
